module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/flea_infobanner02.36fbcd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product_info/flea_infobanner02.png
// module id = apl2
// module chunks = 0